// extracted by mini-css-extract-plugin
export default {"wrapper":"item_wrapper__KVlDP","btn":"item_btn__Mab7k"};